import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Typography,
  Badge,
  Popover,
  ListItemIcon,
  Chip,
  Stack,
  Avatar,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import { getAvatarDisplayUrl } from '../../utils/imageUrlUtils'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'
import CloseIcon from '@mui/icons-material/Close'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { getCurrentConfig } from '../../api/commonApi'
import { setRateCnyToVnd } from '../../redux/ducks/commonDucks'
import { AppDispatch, RootState } from '../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import routerConstants from '../../constants/routerConstants'
import { getUserInfo, logOut, getProjectInfo, getBranchInfo } from '../../utils/userUtils'
import * as queryString from 'query-string'
import { getListAllNotification } from '../../redux/ducks/notificationDucks'
import * as notificationApi from '../../api/notificationApi'
import moment from 'moment'
import * as userApi from '../../api/userApi'
import { saveAccessToken, saveProjectInfo, saveUserInfo, saveBranchInfo } from '../../utils/userUtils'
import { getListUnitReport, getListUnit, getListCategorie } from '../../redux/ducks/settingDucks'
import { getListTransProvider } from '../../redux/ducks/transProviderDucks'
import { getListProductGroup } from '../../redux/ducks/productGroupDucks'
import { showMessage } from '../../utils/commonUtils'
import { useMenuChucNang } from '../../hooks/useMenuChucNang'
import { CHUC_NANG_PERMISSION_CODES } from '../../constants/permissionConstants'
import { getListMyDuAn } from '../../redux/ducks/userDucks'
import { PurchasesRequestChatByIdHost } from '../order/purchasesRequest/partials/PurchasesRequestCmtChatCells'
import { extractCmtFromNotificationContent } from '../order/purchasesRequest/purchasesRequestChatUtils'
import MuahangTopNavBar from './MuahangTopNavBar'
import ThemeAccentPicker from './ThemeAccentPicker'
import {
  muahangKiotLike,
  TOP_NAV_HEIGHT_PX,
  buildKiotHeaderIconButtonSx,
  getKiotHeaderNavHighlightSurfaceSx,
  getKiotHeaderNavHoverBackground,
  KIOT_HEADER_NAV_PADDING_X,
  KIOT_HEADER_NAV_PADDING_Y,
} from './muahangKiotTokens'

export enum notifyType {
  CANXACNHANBAOGIA = 'CANXACNHANBAOGIA',
  COTHAYDOIBAOGIA = 'COTHAYDOIBAOGIA',
  COYEUCAUMUA = 'COYEUCAUMUA',
  CMTYEUCAUMUA = 'CMTYEUCAUMUA',
  COYEUCAUTACH = 'COYEUCAUTACH',
  COYEUCAUTHANHTOAN = 'COYEUCAUTHANHTOAN',

  COYEUCAUTIM = 'COYEUCAUTIM',
  CANXACNHANDONTIM = 'CANXACNHANDONTIM',
  COTHAYDOIDONTIM = 'COTHAYDOIDONTIM',
}

const EMPTY_NOTIFICATION_LIST: Record<string, never> = {}

const { innerHeight: height } = window

interface Props {}

const HeaderMenu: React.FC<Props> = () => {
  const theme = useTheme()
  const dispatch: AppDispatch = useDispatch()
  const { hasChucNangByCode } = useMenuChucNang()
  const userInfo = getUserInfo()
  const accountAvatarUrl = getAvatarDisplayUrl(
    userInfo?.userProfile?.avatar || userInfo?.avatar || '',
  )
  const projectInfo = getProjectInfo()
  const branchInfo = getBranchInfo()
  const notificationAllList = useSelector(
    (state: RootState) => state.notification.notificationAllList ?? EMPTY_NOTIFICATION_LIST,
  )
  const myDuAnList = useSelector((state: RootState) => state.user.myDuAnList)

  const isMounted = useRef(true)
  const notifAnchorRef = useRef<HTMLElement | null>(null)
  const [count, setCount] = useState(0)
  const [countNoty, setCountNoty] = useState({
    countXnbg: 0,
    countTdbg: 0,
    countYcm: 0,
    countCmtYcm: 0,
    countYct: 0,
    countYctt: 0,
    countXacNhanDonTim: 0,
    countThayDoiBaoGiaTimHang: 0,
    countCoYeuCauTim: 0,
  })
  const [notification, setNotification] = useState<any[]>([])
  const [visible, setVisible] = useState<boolean>(false)
  const [refType, setRefType] = useState<string>('ALL')
  const [duAns, setDuAns] = useState<any[]>([])
  const [chatYcmOpen, setChatYcmOpen] = useState<{
    id: string | number
    highlightCmt?: string
    highlightAt?: string
  } | null>(null)
  const [branchMenuAnchorEl, setBranchMenuAnchorEl] = useState<HTMLElement | null>(null)
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState<HTMLElement | null>(null)

  const branchColumnWidthPx = muahangKiotLike.kiotHeaderBranchColumnWidthPx
  const navActiveR = muahangKiotLike.navItemActiveRadiusPx

  const navHighlightColors = useMemo(
    () => ({
      activeBg: theme.palette.muahang.navItemActiveBg,
      activeBgHover: theme.palette.muahang.navItemActiveBgHover,
    }),
    [theme.palette.muahang.navItemActiveBg, theme.palette.muahang.navItemActiveBgHover],
  )

  const headerIconButtonSx = useMemo(
    () => ({
      ...buildKiotHeaderIconButtonSx(navHighlightColors),
      alignSelf: 'stretch' as const,
      height: '100%',
      minHeight: 0,
    }),
    [navHighlightColors],
  )

  const branchSwitcherMenuPaperSx = useMemo(
    () => ({
      py: 0.5,
      px: 0.25,
      width: branchColumnWidthPx,
      minWidth: branchColumnWidthPx,
      maxWidth: branchColumnWidthPx,
      boxSizing: 'border-box' as const,
      maxHeight: 'min(70vh, 480px)' as const,
      overflow: 'auto' as const,
      bgcolor: theme.palette.muahang.kiotSubmenuPanelBg,
      color: muahangKiotLike.topNavText,
      borderRadius: `${muahangKiotLike.kiotSubmenuPaperRadiusPx}px`,
      boxShadow: '0 6px 16px rgba(0,0,0,0.22)',
      mt: 0.5,
      backgroundImage: 'none',
    }),
    [branchColumnWidthPx, theme.palette.muahang.kiotSubmenuPanelBg],
  )

  const rightToolbarSx = {
    display: 'flex',
    alignItems: 'stretch',
    flexShrink: 0,
    height: '100%',
    boxSizing: 'border-box',
    gap: `${muahangKiotLike.kiotHeaderRightItemGapPx}px`,
    py: `${muahangKiotLike.kiotHeaderRightItemMarginYPx}px`,
  } as const

  const filter = {
    from_date: moment().subtract(60, 'days').format('YYYYMMDD'),
    to_date: moment().format('YYYYMMDD'),
  }

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    async function fetchExChangeRate() {
      try {
        const res = await getCurrentConfig()
        if (isMounted.current) {
          const rate = res.data.rateCnyVnd
          dispatch(setRateCnyToVnd(Number(rate.toFixed(2))))
        }
      } catch (error) {
        // Handle error silently
      }
    }
    fetchExChangeRate()
  }, [])

  useEffect(() => {
    getCommonData()
  }, [])

  const getCommonData = () => {
    dispatch(getListMyDuAn({}))
    dispatch(getListUnitReport())
    dispatch(getListUnit())
    dispatch(getListCategorie())
    dispatch(getListTransProvider({}))
    dispatch(getListProductGroup({}))
  }

  useEffect(() => {
    let duAns: any[] = []

    if (Array.isArray(myDuAnList?.data) && myDuAnList?.data?.length > 0) {
      myDuAnList?.data?.map((item: any) => {
        if (Array.isArray(item.userNhomQuyens) && item.userNhomQuyens?.length > 0) {
          item.userNhomQuyens?.map((userNhomQuyen: any) => {
            duAns.push({ ...userNhomQuyen.chiNhanh, key: userNhomQuyen.chiNhanh.id, duAn: item })
          })
        } else {
          if (Array.isArray(item.chiNhanhs) && item.chiNhanhs?.length > 0) {
            item.chiNhanhs?.map((chiNhanh: any) => {
              duAns.push({ ...chiNhanh, key: chiNhanh.id, duAn: item })
            })
          }
        }
      })
      if (isMounted.current) {
        setDuAns(duAns)
      }
    }
  }, [myDuAnList])

  useEffect(() => {
    getNotification()

    const myInterval = window.setInterval(() => {
      getNotification()
    }, 3000 * 60)

    return () => clearInterval(myInterval)
  }, [])

  const getNotification = () => {
    if (!isMounted.current) return
    const stringified = queryString.stringify({ ...filter, page: 1, page_size: 1000 }, { skipEmptyString: true })
    dispatch(getListAllNotification(stringified))
  }

  useEffect(() => {
    if (!isMounted.current) return

    setCount(notificationAllList?.additionalData?.unReadCount || 0)
    let notify: any[] = []
    let notifyWatched: any[] = []
    let countXnbg = 0
    let countTdbg = 0
    let countYcm = 0
    let countCmtYcm = 0
    let countYct = 0
    let countYctt = 0
    let countXacNhanDonTim = 0,
      countThayDoiBaoGiaTimHang = 0,
      countCoYeuCauTim = 0
    if (Array.isArray(notificationAllList.data) && notificationAllList.data.length > 0) {
      notificationAllList.data.map((item) => {
        countXnbg += !item.watched && item.refType == notifyType.CANXACNHANBAOGIA ? 1 : 0
        countTdbg += !item.watched && item.refType == notifyType.COTHAYDOIBAOGIA ? 1 : 0
        countYcm += !item.watched && item.refType == notifyType.COYEUCAUMUA ? 1 : 0
        countCmtYcm += !item.watched && item.refType == notifyType.CMTYEUCAUMUA ? 1 : 0
        countYct += !item.watched && item.refType == notifyType.COYEUCAUTACH ? 1 : 0
        countYctt += !item.watched && item.refType == notifyType.COYEUCAUTHANHTOAN ? 1 : 0

        countXacNhanDonTim += !item.watched && item.refType == notifyType.CANXACNHANDONTIM ? 1 : 0
        countThayDoiBaoGiaTimHang += !item.watched && item.refType == notifyType.COTHAYDOIDONTIM ? 1 : 0
        countCoYeuCauTim += !item.watched && item.refType == notifyType.COYEUCAUTIM ? 1 : 0

        if (item.refType == refType || refType == 'ALL') {
          if (item.watched) {
            notifyWatched.push(item)
          } else {
            notify.push(item)
          }
        }
      })
    }

    if (isMounted.current) {
      setCountNoty({
        countXnbg: countXnbg,
        countTdbg: countTdbg,
        countYcm: countYcm,
        countCmtYcm: countCmtYcm,
        countYct: countYct,
        countYctt: countYctt,
        countXacNhanDonTim: countXacNhanDonTim,
        countThayDoiBaoGiaTimHang: countThayDoiBaoGiaTimHang,
        countCoYeuCauTim: countCoYeuCauTim,
      })
      setNotification([...notify, ...notifyWatched])
    }
  }, [notificationAllList, refType])

  const updateNofification = async (item: any) => {
    if (!item.watched) {
      await notificationApi.updateNotification(item.id)
      getNotification()
    }

    if (item.refType == notifyType.CANXACNHANBAOGIA || item.refType == notifyType.COTHAYDOIBAOGIA) {
      window.open(routerConstants.pricingConfirm.detail.replace(':id', item.refId))
    } else if (item.refType == notifyType.CMTYEUCAUMUA) {
      setChatYcmOpen({
        id: item.refId,
        highlightCmt: extractCmtFromNotificationContent(item.content),
        highlightAt: item.createdAt,
      })
    } else if (item.refType == notifyType.COYEUCAUMUA) {
      window.open(routerConstants.pricing.add)
    } else if (item.refType == notifyType.COYEUCAUTHANHTOAN) {
      window.open(routerConstants.requestPayment.list)
    } else {
      window.open(routerConstants.pricing.add)
    }
    setVisible(false)
  }

  const updateNofificationReadAll = async () => {
    await notificationApi.updateNotification('-1')
    getNotification()
    setVisible(false)
  }

  const changeBranch = async (item: any) => {
    const res = await userApi.changeBranch(item.duAnId, item.id)
    console.log('res', res)
    saveAccessToken(res.data.access_token)
    saveBranchInfo(JSON.stringify(res.data.chiNhanh))
    saveProjectInfo(JSON.stringify(res.data.duAn))
    const resUser = await userApi.getUserInfo()
    saveUserInfo(JSON.stringify(resUser.data))
    window.location.reload()
  }

  const handleSyncUser = async () => {
    try {
      await userApi.syncUser()
      showMessage('success', 'Đồng bộ user thành công')
    } catch (error) {
      showMessage('error', 'Đồng bộ user thất bại')
    }
  }

  const handleNotificationToggle = (event: React.MouseEvent<HTMLElement>) => {
    if (visible) {
      setVisible(false)
      notifAnchorRef.current = null
    } else {
      notifAnchorRef.current = event.currentTarget
      setVisible(true)
    }
  }

  const closeNotificationPopover = () => {
    setVisible(false)
    notifAnchorRef.current = null
  }

  const isHaveChucNangSyncUser = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_SYNC_USER)
  const isHaveChucNangNotiyConfirmPricing = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_CANXACNHANBAOGIA,
  )
  const isHaveChucNangNotiyChangePricing = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COTHAYDOIBAOGIA,
  )
  const isHaveChucNangNotiyPurchaseRequest = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUMUA,
  )
  const isHaveChucNangNotiyRequestShare = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUTACH,
  )
  const isHaveChucNangNotiyPaymentRequest = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUTHANHTOAN,
  )
  const isHaveChucNangNotiyConfirmProductPricing = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_CANXACNHANDONTIM,
  )
  const isHaveChucNangNotiyChangeProductPricing = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COTHAYDOIDONTIM,
  )
  const isHaveChucNangNotiySearchRequest = hasChucNangByCode(
    CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUTIM,
  )
  const isHaveChucNangNotiyCmtYcm =
    hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRICING_ADD) ||
    hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PURCHASES_REQUEST_ADD)

  const primary = theme.palette.primary.main

  const notifFilters = useMemo(() => {
    const items: { key: string; label: string; count: number; show: boolean }[] = [
      { key: 'ALL', label: 'Tất cả', count, show: true },
      {
        key: notifyType.CANXACNHANBAOGIA,
        label: 'Xác nhận báo giá',
        count: countNoty.countXnbg,
        show: isHaveChucNangNotiyConfirmPricing,
      },
      {
        key: notifyType.COTHAYDOIBAOGIA,
        label: 'Thay đổi báo giá',
        count: countNoty.countTdbg,
        show: isHaveChucNangNotiyChangePricing,
      },
      {
        key: notifyType.COYEUCAUMUA,
        label: 'Yêu cầu mua',
        count: countNoty.countYcm,
        show: isHaveChucNangNotiyPurchaseRequest,
      },
      {
        key: notifyType.CMTYEUCAUMUA,
        label: 'Cmt YCMH',
        count: countNoty.countCmtYcm,
        show: isHaveChucNangNotiyCmtYcm,
      },
      {
        key: notifyType.COYEUCAUTACH,
        label: 'Yêu cầu tách',
        count: countNoty.countYct,
        show: isHaveChucNangNotiyRequestShare,
      },
      {
        key: notifyType.COYEUCAUTHANHTOAN,
        label: 'Yêu cầu thanh toán',
        count: countNoty.countYctt,
        show: isHaveChucNangNotiyPaymentRequest,
      },
      {
        key: notifyType.CANXACNHANDONTIM,
        label: 'Xác nhận BGTM',
        count: countNoty.countXacNhanDonTim,
        show: isHaveChucNangNotiyConfirmProductPricing,
      },
      {
        key: notifyType.COTHAYDOIDONTIM,
        label: 'Thay đổi BGTM',
        count: countNoty.countThayDoiBaoGiaTimHang,
        show: isHaveChucNangNotiyChangeProductPricing,
      },
      {
        key: notifyType.COYEUCAUTIM,
        label: 'Yêu cầu tìm',
        count: countNoty.countCoYeuCauTim,
        show: isHaveChucNangNotiySearchRequest,
      },
    ]
    return items.filter((i) => i.show)
  }, [
    count,
    countNoty,
    isHaveChucNangNotiyConfirmPricing,
    isHaveChucNangNotiyChangePricing,
    isHaveChucNangNotiyPurchaseRequest,
    isHaveChucNangNotiyCmtYcm,
    isHaveChucNangNotiyRequestShare,
    isHaveChucNangNotiyPaymentRequest,
    isHaveChucNangNotiyConfirmProductPricing,
    isHaveChucNangNotiyChangeProductPricing,
    isHaveChucNangNotiySearchRequest,
  ])

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          position: 'relative',
          bgcolor: theme.palette.muahang.headerBg ?? muahangKiotLike.kiotShellHeaderBg,
          color: muahangKiotLike.topNavText,
          borderBottom: 'none',
          boxShadow: 'none',
          '& .MuiToolbar-root': {
            alignItems: 'stretch',
            minHeight: TOP_NAV_HEIGHT_PX,
            maxHeight: TOP_NAV_HEIGHT_PX,
          },
        }}
      >
        <Toolbar
          disableGutters
          variant="dense"
          sx={{
            width: '100%',
            minHeight: TOP_NAV_HEIGHT_PX,
            maxHeight: TOP_NAV_HEIGHT_PX,
            height: TOP_NAV_HEIGHT_PX,
            py: 0,
            px: `${muahangKiotLike.kiotShellHeaderPaddingXPx}px`,
            m: 0,
            gap: 0,
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'stretch',
              alignSelf: 'stretch',
              height: '100%',
              flexShrink: 0,
              width: branchColumnWidthPx,
              minWidth: branchColumnWidthPx,
              maxWidth: branchColumnWidthPx,
              boxSizing: 'border-box',
              py: `${muahangKiotLike.kiotHeaderRightItemMarginYPx}px`,
            }}
          >
            <Box
              component="button"
              type="button"
              aria-label="Đổi chi nhánh"
              onClick={(e) => setBranchMenuAnchorEl(e.currentTarget)}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                alignSelf: 'stretch',
                height: '100%',
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                cursor: 'pointer',
                textAlign: 'left',
                px: KIOT_HEADER_NAV_PADDING_X,
                py: KIOT_HEADER_NAV_PADDING_Y,
                m: 0,
                boxShadow: 'none',
                color: muahangKiotLike.topNavText,
                fontFamily: muahangKiotLike.kiotFontStack,
                letterSpacing: '0.01em',
                transition: 'background-color 120ms ease, border-color 120ms ease',
                borderRadius: `${navActiveR}px`,
                ...getKiotHeaderNavHighlightSurfaceSx(true, navHighlightColors),
                '&:hover': {
                  bgcolor: getKiotHeaderNavHoverBackground(true, navHighlightColors),
                  border: muahangKiotLike.navItemActiveBorder,
                  boxShadow: 'none',
                },
                '&:active': { boxShadow: 'none', border: muahangKiotLike.navItemActiveBorder },
              }}
            >
              <BusinessOutlinedIcon sx={{ fontSize: 18, color: 'inherit', flexShrink: 0, mr: 0.6 }} />
              <Typography
                component="span"
                variant="caption"
                sx={{
                  flex: 1,
                  minWidth: 0,
                  fontWeight: 700,
                  fontFamily: muahangKiotLike.kiotFontStack,
                  fontSize: `${muahangKiotLike.kiotNavFontSizePx}px`,
                  lineHeight: muahangKiotLike.kiotLineHeight,
                  color: 'inherit',
                  whiteSpace: 'normal',
                  overflow: 'visible',
                  textOverflow: 'clip',
                  wordBreak: 'break-word',
                }}
              >
                {projectInfo?.ten} - {branchInfo?.ten}
              </Typography>
            </Box>
          </Box>

          <Menu
            anchorEl={branchMenuAnchorEl}
            open={Boolean(branchMenuAnchorEl)}
            onClose={() => setBranchMenuAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            slotProps={{
              paper: { sx: branchSwitcherMenuPaperSx },
              list: {
                dense: true,
                sx: { display: 'flex', flexDirection: 'column', gap: '5px', py: 0.5, px: 0.25, width: '100%' },
              },
            }}
          >
            {duAns.map((item, index) => {
              const isActive =
                item.id != null &&
                branchInfo?.id != null &&
                String(item.id) === String(branchInfo.id)
              const rSub = muahangKiotLike.kiotSubmenuItemRadiusPx
              return (
                <MenuItem
                  key={index}
                  selected={isActive}
                  onClick={() => {
                    setBranchMenuAnchorEl(null)
                    changeBranch(item)
                  }}
                  disableRipple
                  sx={{
                    mx: 0.75,
                    my: 0,
                    py: 0.875,
                    px: 1,
                    minHeight: 36,
                    borderRadius: `${rSub}px`,
                    color: muahangKiotLike.topNavText,
                    fontFamily: muahangKiotLike.kiotFontStack,
                    fontSize: `${muahangKiotLike.kiotNavFontSizePx}px`,
                    lineHeight: muahangKiotLike.kiotLineHeight,
                    fontWeight: isActive ? 700 : muahangKiotLike.kiotNavFontWeight,
                    border: isActive ? muahangKiotLike.navItemActiveBorder : '1px solid transparent',
                    transition: 'background-color 120ms ease, border-color 120ms ease',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' },
                    '&.Mui-selected': { bgcolor: 'rgba(255,255,255,0.22)' },
                    '&.Mui-selected:hover': { bgcolor: 'rgba(255,255,255,0.28)' },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 28, color: 'inherit' }}>
                    <BusinessOutlinedIcon sx={{ fontSize: 18 }} />
                  </ListItemIcon>
                  {item?.duAn?.ma} - {item?.ma}
                </MenuItem>
              )
            })}
          </Menu>

          <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'stretch', height: '100%' }}>
            <MuahangTopNavBar />
          </Box>

          <Box sx={rightToolbarSx}>
            {isHaveChucNangSyncUser ? (
              <IconButton
                size="small"
                color="inherit"
                aria-label="Đồng bộ user"
                onClick={handleSyncUser}
                sx={headerIconButtonSx}
              >
                <SyncOutlinedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            ) : null}

            <ThemeAccentPicker />

            <IconButton
              size="small"
              color="inherit"
              aria-label="Tài khoản"
              aria-haspopup="true"
              aria-expanded={Boolean(accountMenuAnchorEl)}
              onClick={(e) => setAccountMenuAnchorEl(e.currentTarget)}
              sx={{
                ...headerIconButtonSx,
                p: 0,
                overflow: 'hidden',
              }}
            >
              {accountAvatarUrl ? (
                <Avatar
                  src={accountAvatarUrl}
                  alt={userInfo?.username || 'Tài khoản'}
                  sx={{
                    width: '100%',
                    height: '100%',
                    fontSize: 15,
                    fontWeight: 700,
                    borderRadius: 'inherit',
                    bgcolor: 'transparent',
                    '& img': { objectFit: 'cover' },
                  }}
                />
              ) : (
                <AccountCircleOutlinedIcon sx={{ fontSize: 20 }} />
              )}
            </IconButton>
            <Menu
              anchorEl={accountMenuAnchorEl}
              open={Boolean(accountMenuAnchorEl)}
              onClose={() => setAccountMenuAnchorEl(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              slotProps={{
                paper: {
                  sx: {
                    minWidth: 200,
                    mt: 0.5,
                    bgcolor: theme.palette.muahang.kiotSubmenuPanelBg,
                    color: muahangKiotLike.topNavText,
                    borderRadius: `${muahangKiotLike.kiotSubmenuPaperRadiusPx}px`,
                  },
                },
              }}
            >
              <MenuItem disabled dense sx={{ opacity: '1 !important', py: 1 }}>
                <Typography variant="body2" fontWeight={600} noWrap sx={{ maxWidth: 220 }}>
                  {userInfo?.username}
                </Typography>
              </MenuItem>
              <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />
              <MenuItem
                component={Link}
                to={routerConstants.account}
                onClick={() => setAccountMenuAnchorEl(null)}
                sx={{ color: 'inherit' }}
              >
                Tài khoản
              </MenuItem>
              <MenuItem
                component={Link}
                to={routerConstants.settings}
                onClick={() => setAccountMenuAnchorEl(null)}
                sx={{ color: 'inherit' }}
              >
                Cài đặt
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAccountMenuAnchorEl(null)
                  logOut()
                }}
                sx={{ color: 'inherit' }}
              >
                Đăng xuất
              </MenuItem>
            </Menu>

            <IconButton
              size="small"
              color="inherit"
              aria-label="Thông báo"
              aria-haspopup="true"
              aria-expanded={visible}
              onClick={handleNotificationToggle}
              sx={headerIconButtonSx}
            >
              <Badge badgeContent={count > 0 ? count : undefined} color="error" max={999}>
                <NotificationsNoneOutlinedIcon sx={{ fontSize: 18 }} />
              </Badge>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Popover
        open={visible}
        anchorEl={notifAnchorRef.current}
        onClose={closeNotificationPopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              width: 520,
              maxWidth: 'min(96vw, 520px)',
              mt: 0.75,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 2.5,
              boxShadow: '0 16px 48px rgba(15, 23, 42, 0.2)',
              border: '1px solid',
              borderColor: 'divider',
            },
          },
        }}
      >
        <Box
          sx={{
            px: 2.25,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: '#fff',
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.2, color: '#0f172a' }}>
              Thông báo
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {count > 0 ? `${count} chưa đọc` : 'Không có thông báo chưa đọc'}
            </Typography>
          </Box>
          <Button
            size="small"
            startIcon={<DoneAllIcon sx={{ fontSize: 16 }} />}
            onClick={() => updateNofificationReadAll()}
            sx={{ textTransform: 'none', fontWeight: 600, color: primary, flexShrink: 0 }}
          >
            Đọc tất cả
          </Button>
          <IconButton size="small" onClick={closeNotificationPopover} aria-label="Đóng">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box
          sx={{
            px: 2,
            py: 1.25,
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: '#f8fafc',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.75,
          }}
        >
          {notifFilters.map((f) => {
            const active = refType === f.key
            return (
              <Chip
                key={f.key}
                size="small"
                label={f.count > 0 ? `${f.label} (${f.count})` : f.label}
                onClick={() => setRefType(f.key)}
                color={active ? 'primary' : 'default'}
                variant={active ? 'filled' : 'outlined'}
                sx={{
                  fontWeight: active ? 700 : 500,
                  borderRadius: '8px',
                  height: 28,
                  bgcolor: active ? primary : '#fff',
                  borderColor: active ? primary : 'rgba(15,23,42,0.12)',
                  '& .MuiChip-label': { px: 1, fontSize: '0.75rem' },
                }}
              />
            )
          })}
        </Box>

        <Box sx={{ overflow: 'auto', maxHeight: Math.min(height - 220, 560), bgcolor: '#f1f5f9', p: 1.25 }}>
          {notification.length === 0 ? (
            <Box sx={{ py: 6, px: 2, textAlign: 'center', bgcolor: '#fff', borderRadius: 2 }}>
              <NotificationsNoneOutlinedIcon sx={{ fontSize: 42, color: 'text.disabled', mb: 1 }} />
              <Typography variant="body2" color="text.secondary">
                Không có thông báo
              </Typography>
            </Box>
          ) : (
            <Stack spacing={1}>
              {notification.map((item, index) => {
                const unread = !item.watched
                return (
                  <Box
                    key={item.id ?? index}
                    onClick={() => updateNofification(item)}
                    sx={{
                      position: 'relative',
                      px: 1.75,
                      py: 1.5,
                      pl: 2,
                      cursor: 'pointer',
                      borderRadius: 2,
                      bgcolor: '#fff',
                      border: '1px solid',
                      borderColor: unread ? 'rgba(0, 112, 244, 0.22)' : 'rgba(15, 23, 42, 0.08)',
                      boxShadow: unread
                        ? '0 2px 8px rgba(0, 112, 244, 0.08)'
                        : '0 1px 2px rgba(15, 23, 42, 0.04)',
                      transition: 'border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 10,
                        bottom: 10,
                        width: 3,
                        borderRadius: '0 3px 3px 0',
                        bgcolor: unread ? primary : 'transparent',
                      },
                      '&:hover': {
                        borderColor: unread ? primary : 'rgba(15, 23, 42, 0.16)',
                        boxShadow: '0 4px 14px rgba(15, 23, 42, 0.1)',
                      },
                    }}
                  >
                    <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="space-between">
                      <Typography
                        variant="body2"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          fontWeight: unread ? 700 : 600,
                          color: unread ? primary : '#0f172a',
                          fontSize: '0.9rem',
                          lineHeight: 1.4,
                          pr: 1,
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          flexShrink: 0,
                          fontSize: '0.7rem',
                          fontWeight: 600,
                          color: unread ? primary : '#64748b',
                          bgcolor: unread ? 'rgba(0, 112, 244, 0.08)' : '#f1f5f9',
                          borderRadius: '999px',
                          px: 1,
                          py: 0.25,
                          lineHeight: 1.6,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {moment(item.createdAt).format('DD/MM HH:mm')}
                      </Typography>
                    </Stack>
                    <Box
                      sx={{
                        mt: 0.75,
                        fontSize: '0.8125rem',
                        lineHeight: 1.5,
                        color: '#475569',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        '& p': { m: 0 },
                        '& a': { color: primary, fontWeight: 600 },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: item.watched
                          ? String(item.content || '').replace(/#0000ff;/gi, 'inherit;')
                          : item.content,
                      }}
                    />
                  </Box>
                )
              })}
            </Stack>
          )}
        </Box>

        <Box
          sx={{
            px: 1.5,
            py: 1,
            borderTop: '1px solid',
            borderColor: 'divider',
            bgcolor: '#f8fafc',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            size="small"
            endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
            onClick={() => window.open(routerConstants.notification.list)}
            sx={{ textTransform: 'none', fontWeight: 600, color: primary }}
          >
            Xem tất cả thông báo
          </Button>
        </Box>
      </Popover>

      <PurchasesRequestChatByIdHost
        yeuCauMuaId={chatYcmOpen?.id ?? null}
        highlightCmt={chatYcmOpen?.highlightCmt}
        highlightAt={chatYcmOpen?.highlightAt}
        onClose={() => setChatYcmOpen(null)}
      />
    </>
  )
}

export default HeaderMenu
